import { BadgeCell, DateCell, dateFormatter, formatNumber, formattedCell } from '@dec/shared';
import { type ColDef, type ValueFormatterParams } from 'ag-grid-community';
import { t } from 'i18next';
import { Search } from 'react-bootstrap-icons';

import { ActionsGrid } from '@/app/components/grid';
import { type ActionColumn } from '@/app/components/grid/actions-column';

import { type PaymentSummary } from '../../models/Payment';

export const getPaymentColumns = (
  onView: (payment: PaymentSummary) => void
): Array<ColDef<PaymentSummary>> => {
  const actions: Array<ActionColumn> = [
    {
      icon: Search,
      variant: 'secondary',

      onClick: async (row: PaymentSummary) => {
        // se invoca al método para apertura
        onView(row);
      }
    }
  ];

  const columns: Array<ColDef<PaymentSummary>> = [
    {
      headerName: t('taxes.header.actions'),
      cellRenderer: ActionsGrid,
      cellRendererParams: {
        actions: actions
      }
    },
    {
      headerName: t('taxpayer-payments.label.date-payment'),
      field: 'paymentDate',
      ...formattedCell(dateFormatter, DateCell)
    },
    {
      headerName: t('config.tin'),
      field: 'tin',
      valueFormatter: (params: ValueFormatterParams<PaymentSummary>) => {
        return params.value ?? '---';
      }
    },
    {
      headerName: t('taxpayer-payments.label.amount'),
      field: 'amount',
      cellStyle: () => {
        return { 'text-align': 'right' };
      },
      valueFormatter: (params: ValueFormatterParams<PaymentSummary>) => {
        const code = params?.data?.currency?.code;
        const codeCurrency = code ? code : '';

        return `${formatNumber(params.value)} ${codeCurrency}`;
      }
    },
    {
      headerName: t('taxreturn-report.label.taxreturnStatus'),
      field: 'status',
      ...formattedCell(
        (params: ValueFormatterParams): string => {
          return t(`common.taxreturn-status.${params.value}`);
        },
        BadgeCell((params) => {
          switch (params.value) {
            case 'reconciled':
              return 'success';
            case 'pending':
              return 'secondary';
            default:
              return 'danger';
          }
        })
      )
    },
    {
      headerName: t('taxpayer-payments.label.date-payment-bank'),
      field: 'paymentTransaction.date',
      ...formattedCell(dateFormatter, DateCell)
    },
    {
      headerName: t('taxpayer-payments.label.amountBank'),
      field: 'paymentTransaction.amount',
      cellStyle: () => {
        return { 'text-align': 'right' };
      },
      valueFormatter: (params: ValueFormatterParams) => {
        const code = params?.data?.reconciliationOfPayments?.paymentsReceived?.currencyCode;
        const codeCurrency = code ? code : '';

        return params.value ? `${formatNumber(params.value)} ${codeCurrency}` : '---';
      }
    },
    {
      headerName: t('taxpayer-payments.label.swiftNumber'),
      field: 'paymentTransaction.swift',
      valueFormatter: (params: ValueFormatterParams) => {
        return params.value ?? '---';
      }
    },
    {
      headerName: t('common.label.paymentReference'),
      field: 'paymentTransaction.reference',
      valueFormatter: (params: ValueFormatterParams) => {
        return params.value ?? '---';
      }
    }
  ];

  return columns;
};
